"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("./config");
exports.ResponsiveConfig = config_1.ResponsiveConfig;
exports.ResponsiveState = config_1.ResponsiveState;
exports.ResponsiveConfigInterface = config_1.ResponsiveConfigInterface;
var responsive_base_1 = require("./responsive-base");
exports.RESPONSIVE_BASE = responsive_base_1.RESPONSIVE_BASE;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2032928750/src/~/ng2-responsive/config/index.js
// module id = rTPq
// module chunks = 6